// Wrapper for papaparse UMD module to work with ES modules
// Use namespace import since papaparse is a UMD module without default export
// @ts-ignore
import * as PapaModule from 'papaparse'

// Extract Papa from the module - UMD modules can export in different ways
let Papa = null

// Try to get Papa from the module
if (PapaModule.default) {
  Papa = PapaModule.default
} else if (PapaModule.Papa) {
  Papa = PapaModule.Papa
} else if (typeof PapaModule === 'object' && PapaModule.parse) {
  Papa = PapaModule
} else {
  // Last resort: use the module itself
  Papa = PapaModule
}

// Fallback to window.Papa if available (for UMD fallback)
if (!Papa || typeof Papa.parse !== 'function') {
  if (typeof window !== 'undefined' && window.Papa) {
    Papa = window.Papa
  }
}

// Verify we have the required methods
if (!Papa || typeof Papa.parse !== 'function') {
  console.warn('PapaParse not properly loaded. Creating stub.')
  Papa = {
    parse: () => { throw new Error('PapaParse not loaded') },
    unparse: () => { throw new Error('PapaParse not loaded') },
  }
}

export default Papa
export const parse = Papa.parse.bind(Papa)
export const unparse = Papa.unparse.bind(Papa)
